import canDownloadImmediatelySetup from "./can-download-immediately";
import doWeKnowYouSetup from "./do-we-know-you";
import letsGetToKnowYouBetterSetup from "./lets-get-to-know-you-better";

export type DialogName = 'can-download-immediately'|'do-we-know-you'|'lets-get-to-know-you-better'|'please-check-your-email'|'whitepaper-forms-waiting';
export type ControllableDialog = {beforeShow?(): void, afterShow?(): void, beforeHide?(): void, afterHide?(): void};

export class DialogController {
	private readonly availableDialogs: Record<DialogName, ControllableDialog>;
	private currentlyVisible?: DialogName;
	private formFilledOutValue = false;
	public  askedForEmail = false;

	public activeHref?: string;

	constructor(
		public readonly dialog: HTMLDialogElement,
		public readonly disconnectAnchors: () => void,
		private readonly actualPerformDownload: (href: string, errorHandler: (resp: Response) => void) => Promise<void>
	) {
		this.availableDialogs = {
			'can-download-immediately': canDownloadImmediatelySetup(this),
			'do-we-know-you': doWeKnowYouSetup(this),
			'lets-get-to-know-you-better': letsGetToKnowYouBetterSetup(this),
			'please-check-your-email': {},
			'whitepaper-forms-waiting': {}
		};
		const closeHandler = () => {
			if (this.currentlyVisible) {
				this.hide(this.currentlyVisible);
			}
		};
		dialog.addEventListener('close', closeHandler);
		dialog.addEventListener('cancel', closeHandler);
	}

	get currentlyVisibleDialog() {
		return this.currentlyVisible;
	}

	show(name: DialogName) {
		if (this.currentlyVisible !== name) {
			if (this.currentlyVisible) {
				this.hide(this.currentlyVisible);
			}
			const soonToBeVisibleDialog = this.availableDialogs[name];
			soonToBeVisibleDialog.beforeShow?.();
			const currentlyVisibleDialogElement = document.getElementById(name);
			if (currentlyVisibleDialogElement instanceof HTMLElement) {
				currentlyVisibleDialogElement.style.display = '';
			}
			soonToBeVisibleDialog.afterShow?.();
			this.currentlyVisible = name;
		}
		if (!this.dialog.open) {
			this.dialog.showModal();
		}
	}
	hide(name: DialogName) {
		if (this.currentlyVisible === name) {
			this.currentlyVisible = undefined;
			const currentlyVisibleDialog = this.availableDialogs[name];
			currentlyVisibleDialog.beforeHide?.();
			const currentlyVisibleDialogElement = document.getElementById(name);
			if (currentlyVisibleDialogElement instanceof HTMLElement) {
				currentlyVisibleDialogElement.style.display = 'none';
			}
			currentlyVisibleDialog.afterHide?.();
		}
	}
	close() {
		if (this.currentlyVisible !== undefined) {
			this.hide(this.currentlyVisible);
		}
		if (this.dialog.open) {
			this.dialog.close();
		}
	}

	begin(name: DialogName, href: string) {
		this.activeHref = href;
		this.show(name);
	}

	performDownload(errorHandler: (resp: Response) => void) {
		return this.actualPerformDownload(this.activeHref!, errorHandler);
	}

	get formFilledOut() {
		return this.formFilledOutValue;
	}
	// noinspection JSUnusedGlobalSymbols this is here to prevent direct assignments from causing problems
	set formFilledOut(value: boolean) {
		this.setFormFilledOut(value);
	}
	setFormFilledOut(value: boolean) {
		if (this.formFilledOutValue !== value) {
			this.formFilledOutValue = value;
			const displayValue = value ? '' : 'none';
			for (let element of document.querySelectorAll<HTMLElement>(".if-filled-out-form")) {
				element.style.display = displayValue;
			}
		}
	}
}
